let reloadingAfterPreloadError = false;

/**
 * Tracks the brief window between triggering a recovery reload for a stale chunk
 * and the page actually being replaced.
 *
 * Vite swallows the preload rejection once our handler calls `preventDefault()`,
 * so the dynamic `import()` resolves to `undefined` and downstream code (e.g. an
 * Inertia resolver reading `.default`) throws a misleading error in that window.
 * Error reporting checks this state to drop that noise — the reload is expected
 * and self-healing, not a real failure. The flag never needs resetting: the
 * reload replaces the document, so a fresh page load starts back at `false`.
 */
export function markReloadingAfterPreloadError(): void {
  reloadingAfterPreloadError = true;
}

export function isReloadingAfterPreloadError(): boolean {
  return reloadingAfterPreloadError;
}
